import React, { useState, useEffect } from 'react'
import Button from "@mui/material/Button";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import Axios from "axios";
import { API_URL_UMS } from '../../../Constant';

const AssignInterfacePermission = (props) => {
  const { userID } = props;
  const [role, setRole] = useState("")
  const [roleError, setRoleError] = useState(null)
  const [selectPermission, setSelectPermission] = useState([])
  const [roleList, setRoleList] = useState([])
  const [success, setSucces] = useState("")
  const [allPermission, setAllPermission] = useState([])
  const [assignedPermission, setAssignedPermission] = useState([])
  const [referenceNumber, setReferenceNumber] = useState("")
console.log("assignedPermission : ", assignedPermission)
  const onPermissionSubmit = (e) => {
    e.preventDefault()
    if (role === "" || role === "Select Role") {
      setRole("")
      setRoleError("Required")
      return 0;
    }

    let unique = [...new Set(assignedPermission)]
    let postObject = {
      "role": role,
      "permissions": unique.toString(),
      "referenceNumber": referenceNumber,
      "assignedTo": "",
      "userId": userID
    }
    console.log("postObjectpostObject : ", assignedPermission, assignedPermission.toString(), postObject)
    Axios({
      method: "POST",
      url: `${API_URL_UMS}audit/role`,
      data: postObject,
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
        "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
      },
    })
      .then(async (response) => {
        // setRole("")
        setSucces(response.data)
        setTimeout(() => {
          setSucces("")
        }, 5000)
      })
      .catch((err) => {
      });


  }

  const onPermissionNext = () => {
    let unique = [...new Set([...assignedPermission, ...selectPermission])]
    setAssignedPermission(unique)
    setSelectPermission([])
  }

  const onPermissionPrev = () => {
    const update = assignedPermission.filter((item) => !selectPermission.includes(item));
    setAssignedPermission(update)
    setSelectPermission([])
  }

  const onGetRole = (role) => {
    if (role === "Select Role") {
      setAllPermission([])
      setAssignedPermission([])
      setRole("")
      return 0;
    }
    setRoleError(null)
    setRole(role)
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      `${API_URL_UMS}audit/role-Permissions?role=${role}`,
      requestOptions
    )
      .then((response) => {
        const allPer = response.data.allPermissions.split(',')
        setAllPermission(allPer)
        const selectedPer = response.data.permissions.split(',')
        setAssignedPermission(selectedPer)
        console.log("assignedPermission : ", allPer)
        console.log("assignedPermission : ",response.data.permissions, selectedPer)
        console.log("response.data :", response.data.allPermissions, allPer)
      })
      .catch((error) => {

      });
  }

  useEffect(() => {
    const requestOptions = {
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
      },
    };
    Axios.get(
      `${API_URL_UMS}audit/role`,
      requestOptions
    )
      .then((response) => {
        setRoleList(response.data)
      })
      .catch((error) => {
      });
  }, [])

  const onSelectPermission = (item) => {
    setSelectPermission([...selectPermission, item])
  }
  return (
    <>
      <div className='row py-3'>
        <div className='col-md-5 mx-auto  p-3'>
          <form className='formField'>
            <div className="form-group row">
              <label htmlFor="validationScreen" className="col-sm-4 col-form-label">Role<span className='text-danger'>*</span> :</label>
              <div className="col-sm-6">
                <select onChange={(e) => onGetRole(e.target.value)} name="role" class={`form-select ${roleError && "formValidation"}`} aria-label="Default select example">
                  <option selected>Select Role</option>
                  {roleList && roleList.length > 0 && roleList.map((item, index) => <option key={index} value={item.role}>{item.role}</option>)}
                </select>
                <small id="validationSubScreen" class="form-text text-right text-danger">{roleError}</small>
              </div>
            </div>

            <div className="form-group row">
              <label htmlFor="referenceNumber" className="col-sm-4 col-form-label text-nowrap">Reference Number</label>
              <div className="col-sm-6">
                <input type="text" name="referenceNumber" onChange={(e) => setReferenceNumber(e.target.value)} className="form-control" id="referenceNumber" value={referenceNumber} />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-5 mx-auto px-3'>
          <b>All Permission</b>
          <div className='card overflow-auto' style={{ height: 400 }}>
            {allPermission && allPermission.map((item, index) => {
              return (
                <p key={index} onClick={() => onSelectPermission(item)} className={`customCursor ${selectPermission.includes(item) && "itemBackground"}`}>
                  {item}
                </p>)
            })}
          </div>
        </div>
        <div className='col-md-1 pt-5'>
          <Button
            variant="contained"
            className="btncolor"
            size="small"
            type="submit"
            sx={{ m: 1 }}
            onClick={onPermissionNext}
            disabled={selectPermission === ""}
          >
            <KeyboardDoubleArrowRightIcon />
          </Button>
          <Button
            variant="contained"
            className="btncolor"
            size="small"
            type="submit"
            sx={{ m: 1 }}
            onClick={onPermissionPrev}
            disabled={selectPermission === ""}
          >
            <KeyboardDoubleArrowLeftIcon />
          </Button>
        </div>
        <div className='col-md-5 mx-auto px-3'>
          <b>Selected Permission</b>
          <div className='card overflow-auto' style={{ height: 400 }}>
            {assignedPermission && assignedPermission.map((item, index) => {
              return (
                <p key={index} onClick={() => onSelectPermission(item)} className={`customCursor ${selectPermission.includes(item) && "itemBackground"}`}>
                  {item}
                </p>)
            })}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 text-success text-center">
          <span >{success}</span>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-12 text-center">
          <Button
            variant="contained"
            className="btncolor"
            size="small"
            type="submit"
            sx={{ m: 1 }}
            onClick={onPermissionSubmit}
          >
            Assign
          </Button>
        </div>
      </div>
    </>
  )
}

export default AssignInterfacePermission